import moment from 'moment'

const formats = {
  de: 'D. MMM YYYY',
  en: 'D MMM YYYY'
}

let locale = document.documentElement.getAttribute('lang')
if (locale !== 'en') {
  locale = 'de'
}
moment.locale(locale)
const format = formats[locale]

export const mapProduct = {
  methods: {
    mapProduct(product) {
      // This mapping is only for the actual product display in the ResultData component
      // We wont continue this pattern.

      // GTIN
      let gtin = product.gtin
      while (gtin[0] === '0') {
        gtin = gtin.substring(1)
      }
      // GPC
      let gpc = product.gpcCategoryCode
      const translation = this.$t(`gpc.${gpc}`)
      if (translation !== `gpc.${gpc}`) {
        gpc = `${translation} (${gpc})`
      }
      // net contents
      let netContents = []
      if (
        typeof product.netContent !== 'undefined' &&
        Array.isArray(product.netContent) &&
        product.netContent.length > 0
      ) {
        netContents = product.netContent.map(netContent => {
          const value = netContent.value
          const unit = this.$tc('uom.' + netContent.unitCode, value)
          return value + '&thinsp;' + unit
        })
      }
      // countries of sale
      let countriesOfSale = []
      if (
        typeof product.countryOfSaleCode !== 'undefined' &&
        Array.isArray(product.countryOfSaleCode) &&
        product.countryOfSaleCode.length > 0
      ) {
        countriesOfSale = product.countryOfSaleCode.map(countryCode =>
          this.$t(`countries.${countryCode.alpha2 || countryCode.numeric}`)
        )
      }
      const result = {
        gtin,
        companyName: product.licenseeName ? product.licenseeName : '',
        brandName: product.brandName,
        description: product.productDescription,
        image: product.productImageUrl ? [product.productImageUrl[0]] : [],
        gpc,
        netContents,
        countriesOfSale,
        updatedOn: moment(product.dateUpdated).format(format),
        isComplete: product.isComplete
      }
      result.complete =
        (result.gtin &&
          result.companyName &&
          result.brandName &&
          result.description &&
          result.image &&
          result.gpc &&
          typeof result.netContents !== 'undefined' &&
          Array.isArray(result.netContents) &&
          result.netContents.length > 0 &&
          typeof result.countriesOfSale !== 'undefined' &&
          Array.isArray(result.countriesOfSale) &&
          result.countriesOfSale.length > 0) ||
        false
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mapProduct.js